
import GridHeader from './components/header';
import GridBody from './components/body';
import GridPaginationComponent from './components/pagination';
import ScrollWheelHorizontal from '../../mixins/scroll-wheel-horizontal';
import { SCROLLABLE_BY_WHEEL_REF_NAME } from '../../mixins/scroll-wheel-horizontal/constants';
import WindowSize from '../../mixins/windowSize';
import { DEFAULT_GRID_SIZES } from './constants';
import StyleClassNamesBuilder from '../../styles/helpers/StyleClassNamesBuilder';
import { GridSizePropsType, GridHeaderPropsEventType, GridColumnCommonOptionsType } from './enums';
import GridScrollPosition, { GridScrollPositionType } from './mixins/grid-scroll-position';
import GridStickyColumns from './mixins/grid-sticky-columns';
import GridPaginationEntity from './components/pagination/entities/GridPagination';
import {
  PAGINATION_ITEMS_PER_PAGE_OPTIONS,
} from './components/pagination/constants';

const TABLE_HEADER_REF_NAME = 'grid-header';

export default {
  name: 'Grid',
  components: {
    GridHeader,
    GridBody,
    GridPaginationComponent,
  },
  mixins: [
    ScrollWheelHorizontal,
    GridScrollPosition,
    GridStickyColumns,
    WindowSize,
  ],
  props: {
    columns: {
      default: () => [],
      type: Array,
    },
    rows: {
      default: () => [],
      type: Array,
    },
    sizes: {
      default: () => DEFAULT_GRID_SIZES,
      type: Array,
    },
    itemsPerPageOptions: {
      default: () => PAGINATION_ITEMS_PER_PAGE_OPTIONS,
      type: Array,
    },
    pagination: {
      default: null,
      type: GridPaginationEntity,
    },
    isCollapsed: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      GridHeaderPropsEventType,
      SCROLLABLE_BY_WHEEL_REF_NAME,
      TABLE_HEADER_REF_NAME,
    };
  },
  computed: {
    currentSize() {
      const currentBreakpointSize = this.sizes.find((size) => (
        size[GridSizePropsType.Breakpoint] === this.currentBreakpoint
      ));

      return currentBreakpointSize || DEFAULT_GRID_SIZES[0];
    },
    hasStickyColumns() {
      return this.columns.some((column) => (
        !!column.options?.[GridColumnCommonOptionsType.IsSticky]
      ));
    },
    tableSize() {
      return this.currentSize[GridSizePropsType.TableSize];
    },
    notCollapsedColumnsAmount() {
      return this.currentSize[GridSizePropsType.NotCollapsedColumnsAmount];
    },
    collapsedColumns() {
      if (!this.isCollapsed) {
        return this.columns;
      }

      return this.columns.slice(0, this.notCollapsedColumnsAmount);
    },
    gridWrapperClassNames() {
      return new StyleClassNamesBuilder('grid__wrapper')
        .addConditionClassNames(Object.values(GridScrollPositionType), this.scrollPosition)
        .addConditionClassName('paginated', !!this.pagination)
        .build();
    },
  },
  watch: {
    tableSize: {
      handler() {
        this.calculateStickyPositions();
      },
    },
  },
  mounted() {
    this.addScrollEventListener(this.$refs[SCROLLABLE_BY_WHEEL_REF_NAME]);
    this.calculateStickyPositions();
  },
  destroyed() {
    this.removeScrollEventListener();
  },
  methods: {
    handlePaginationChange(options) {
      this.$emit('pagination-change', options);
    },
    handleSortingChange(options) {
      this.$emit('sorting-change', options);
    },
    calculateStickyPositions() {
      if (this.hasStickyColumns) {
        this.calculateColumnsLeftPositions(this.columns, this.$refs[TABLE_HEADER_REF_NAME].$refs);
      }
    },
  },
};
